var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDoubleArrowPrev(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "22px",
    viewBox: "0 0 21 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icDoubleArrowPrev") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Main",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Add-arrows",
    transform: "translate(-141.000000, -610.000000)",
    fill: "#999999",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.114353,620.102446 L151.10185,611.118021 C151.593786,610.627326 152.39165,610.627326 152.88381,611.118244 C153.375835,611.610269 153.375835,612.407654 152.883789,612.898458 L144.787196,620.993101 L152.884582,629.087564 C153.376868,629.578607 153.376868,630.376165 152.884359,630.86743 C152.391441,631.357865 151.594745,631.357865 151.102651,630.867014 L142.115432,621.882782 C141.62859,621.396978 141.628234,620.589812 142.114353,620.102446 Z M150.114353,620.102446 L159.10185,611.118021 C159.593786,610.627326 160.39165,610.627326 160.88381,611.118244 C161.375835,611.610269 161.375835,612.407654 160.883789,612.898458 L152.787196,620.993101 L160.884582,629.087564 C161.376868,629.578607 161.376868,630.376165 160.884359,630.86743 C160.391441,631.357865 159.594745,631.357865 159.102651,630.867014 L150.115432,621.882782 C149.62859,621.396978 149.628234,620.589812 150.114353,620.102446 Z",
    id: "icDoubleArrowPrev"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDoubleArrowPrev);
export default __webpack_public_path__ + "static/media/icDoubleArrowPrev.223d8eae333d0fa0f1666717569b10f9.svg";
export { ForwardRef as ReactComponent };